"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setClientInterfaceHook = void 0;
var react_1 = __importDefault(require("react"));
var app_bridge_1 = __importStar(require("@shopify/app-bridge"));
var context_1 = require("../../context");
var packageJson = require('../../package.json');
/**
 * Create an App Bridge client application from a config and pass it as the
 * value to the context provider.
 *
 * @remarks
 * You'll probably want something a little more robust than storing the current
 * app instance in a module-level global.
 *
 * @public
 */
var Provider = /** @class */ (function (_super) {
    __extends(Provider, _super);
    function Provider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.app = _this.appInstance;
        return _this;
    }
    Object.defineProperty(Provider.prototype, "appInstance", {
        get: function () {
            if (!this.app) {
                this.app = app_bridge_1.default(this.props.config);
                if (this.app && this.app.hooks) {
                    this.app.hooks.set(app_bridge_1.LifecycleHook.DispatchAction, exports.setClientInterfaceHook);
                }
            }
            return this.app;
        },
        enumerable: false,
        configurable: true
    });
    Provider.prototype.render = function () {
        return (react_1.default.createElement(context_1.AppBridgeContext.Provider, { value: this.appInstance }, this.props.children));
    };
    return Provider;
}(react_1.default.Component));
exports.default = Provider;
/**
 * Augment actions with clientInterface metadata, identifying use of this library
 *
 * @internal
 */
exports.setClientInterfaceHook = function (next) {
    return function (action) {
        action.clientInterface = {
            name: '@shopify/app-bridge-react',
            version: packageJson.version,
        };
        return next(action);
    };
};
